import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import parse from 'html-react-parser'

const ProductItem = ({ product, featuredImage }) => (
  <Link
    to={`/produkte/${product.slug}`}
    className="relative p-2 border border-transparent group hover:border-slate-200 w-[calc(calc(100%_-_48px)_/_2)] md:w-[calc(calc(100%_-_64px)_/_3)] lg:w-[calc(calc(100%_-_(3_*_48px))_/_4)]"
  >
    <div className="w-full overflow-hidden bg-gray-200 rounded-md aspect-w-1 aspect-h-1 group-hover:opacity-75">
      {/* if we have a featured image for this post let's display it */}
      {featuredImage?.data && (
        <GatsbyImage
          image={featuredImage.data}
          alt={featuredImage.alt}
          className="object-cover object-center w-full h-full lg:w-full lg:h-full"
        />
      )}
    </div>
    <div className="flex justify-between mt-4">
      <div>
        <h3 className="text-base font-medium text-gray-900 group-hover:underline focus-visible:underline">
          {parse(product.title)}
        </h3>
      </div>
    </div>
  </Link>
)

ProductItem.propTypes = {
  product: PropTypes.object,
  featuredImage: PropTypes.object,
}

export default ProductItem
